$(document).ready(function () {
    isIOS = function () {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            return true;
        }
        return false;
    };
    isSafari = function () {
        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
            return true;
        }
        return false;
    };

    if (isIOS()) {
        $('body').addClass('ios');
    }
    if (isSafari()) {
        $('body').addClass('safari');
    }
});